import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {Redirect} from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import StaticNav from '../common/StaticNav';
import { TitleBar } from '../common/theme';
import { convertDictionaryKeys, toArray } from '../../Utils';
import { request, deleteThis } from '../../redux/actions/genericAction';
import Spinner from '../common/generic/Spinner';

const DatabasePage = ({database, request, deleteThis}) =>{
    const [isSavingChanges, setIsSavingChanges] = useState(false);
    const [hasDatabaseData, sethasDatabaseData] = useState(true);
    const [safeCheck, setSafeCheck] = useState('');

    const resetDatabase = () =>{

        if(safeCheck !=='ClearDatabase') return;

        if(!window.confirm('Are you sure you want to delete the database?'))
            return;

        let schoolID = database['getCustomer'].data['ID'];
        let classData = toArray(database['getAllClasses'].data);
        let saveChanges = [];
        classData.forEach(classRec=>{
            let classID = classRec.ClassID;
            saveChanges.push({debug:'Delete Class', func:'deleteTeacher', params: `${classID}~${schoolID}~0`});
            saveChanges.push({debug:'Backup Class', func:'backupTeacher', params: `${classID}`});
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSavingChanges(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;
 
            // pass the link list of saved changes into the database
            request(saveChainedChanges); 
        }
    };

    // check if done saving
    useEffect(()=>{
        if(isSavingChanges){
            if(database.queryCount == 0){
                let customer = database['getCustomer'].data;
                database['getCustomer'].data['NumStudents'] = '0';
                database['getCustomer'].data['NumClasses'] = '0';  
                setIsSavingChanges(false);
                deleteThis('getAllClasses');

                let getAllClassesQuery = {
                    params: customer.ID,
                    func:'getAllClasses',
                  };
                  request(getAllClassesQuery);            
            }
        }
    },[database.queryCount]);

    useEffect(() => {
        if(!database['getCustomer'])
            return sethasDatabaseData(false);
    },[]);

    if (!hasDatabaseData) {
        return <Redirect to='/' />;
    }

    return(<>
        <br/>
        <StaticNav currentTopic={'Database'}/>  

        <Container>
            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Database</h3></Col>
            </TitleBar>
        </Container>            
        <div style={{height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
            <div>
                <Alert variant='danger'>
                    <h4 className="messageTitle"> Reset Database </h4>
                    <p className="textFont"> This will remove all the classes and students and marks from the database.  This might be useful when starting a new school year. </p>
                </Alert>
                <div className="form-group">
                <div className="row">
                    <div className="col-xs-12 col-sm-2"><label htmlFor="name"><span className="textFont">Type <strong>ClearDatabase</strong></span></label></div>
                    <div className="col-xs-12 col-sm-10"><input onChange={e=>setSafeCheck(e.target.value)} value={safeCheck} /></div>
                </div>
                </div>
                {(isSavingChanges)?<Spinner/>
                :<button onClick={()=>resetDatabase()} type="submit" className="btn btn-danger button">Reset Database</button>}
            </div>
        </div>
    </>);
};

const mapStateToProps = state => {
    return {
        database: state.genericReducer
   };
  };
  
export default connect(mapStateToProps, { request, deleteThis })(DatabasePage);
